import { useEffect, useState } from "react";
import axios from "axios";
import { getAuthToken } from "../utils/sessionAuth.js";

const API = `${process.env.REACT_APP_BACKEND_SERVER}/api/mac-wallpaper`;

function authHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function MacWallpaperStatusPanel({ udid }) {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!udid) return undefined;
    let cancelled = false;
    setLoading(true);
    axios.get(`${API}/status/${encodeURIComponent(udid)}`, { headers: authHeaders() })
      .then((res) => {
        if (!cancelled) {
          setRows(res.data?.statuses || []);
          setError("");
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setRows([]);
          setError(err.response?.data?.message || err.message || "Status nicht ladbar");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [udid]);

  if (loading) return <span className="text-muted">Laden…</span>;
  if (error) return <span className="text-danger">{error}</span>;
  if (!rows.length) {
    return (
      <span className="text-muted">
        Kein aktiver Mac-Wallpaper-Auftrag. Nach Zuweisung: Profil installiert ≠ Datei geschrieben.
      </span>
    );
  }

  return (
    <div className="small">
      {rows.map((row) => (
        <div key={`${row.digest}-${row._id}`} className="mb-2">
          <div>
            <strong>{row.label || row.status}</strong>
            {["profile_sent", "acknowledged", "profile_installed"].includes(row.status) ? (
              <span className="text-warning">
                {" "}— Skript nur im Profil (kein .sh im Finder). Voraussetzung: EnableMCXLoginScripts +
                MCXScriptTrust=Anonymous. Nach Ab-/Anmelden:
                /Users/Shared/Xavier/MDM/wallpaper-install.log
              </span>
            ) : null}
            {row.status === "stale" ? (
              <span className="text-danger">
                {" "}— Kein Report vom Gerät. Profilinstallation ≠ Skriptausführung.
              </span>
            ) : null}
            {row.status === "file_confirmed" ? (
              <span className="text-success"> — Datei liegt unter {row.picturePath}</span>
            ) : null}
          </div>
          <div className="text-muted">
            digest {row.digest}
            {row.detail ? ` · ${row.detail}` : ""}
            {row.lastError ? ` · Fehler: ${row.lastError}` : ""}
          </div>
          <div className="text-muted">
            gesendet {row.profileSentAt ? new Date(row.profileSentAt).toLocaleString() : "—"}
            {" · "}installiert {row.profileInstalledAt ? new Date(row.profileInstalledAt).toLocaleString() : "—"}
            {" · "}bestätigt {row.fileConfirmedAt ? new Date(row.fileConfirmedAt).toLocaleString() : "—"}
          </div>
        </div>
      ))}
    </div>
  );
}
